import React from 'react';
import AboutSection from '../components/about/index';
import {Heading3} from '../typography/typography';
import Button from '../components/ui-elements/buttons/index';
import Fade from 'react-reveal/Fade';

export default function FYPContainer() {
    return (
        <AboutSection id="fyp">
            <Heading3>FINAL YEAR PROJECT</Heading3>
            <AboutSection.MainContainer direction="row-reverse">
                <AboutSection.ContentContainer>
                    <Fade>
                        <AboutSection.Image src="/images/fyp1.png" />
                    </Fade>
                </AboutSection.ContentContainer>
                <AboutSection.ContentContainer textContainer fyp>
                    <AboutSection.Text>
                    <Fade left>
                        <AboutSection.Span>
                            <em>
                                 BeMyHand is a voice and eye-gaze controllable web app built for physically challenged people who can not use their hands. The idea is to make the web accessible for them by providing them a complete toolkit which they can use to start working and incorporate self-dependency in them.
                            </em>
                        </AboutSection.Span>
                        </Fade>
                        <Fade left>
                        <AboutSection.Span>
                            <em>
                                 First, our app provides a text editor to write documents using a rich text editor and generate Docx and PDFs. Second, our users can maintain an articles directory where they can store their articles and publish them to share with the rest of the world to showcase their writing skills. Third, they can build a professional CV and download it as a PDF. Fourth, they can make a portfolio webpage where they can add their work, contact information, CV, and other necessary information. And this all with their voice and eye-gaze.
                            </em>
                        </AboutSection.Span> 
                        </Fade>
                    </AboutSection.Text>
                </AboutSection.ContentContainer>
            </AboutSection.MainContainer>
            <Button>
            <a style={{textDecoration: "none"}} href="https://github.com/BeMyHand" target="_blank" rel="noreferrer">
                <Button.Button>
                    GITHUB CODE
                </Button.Button>
            </a>
            <a style={{textDecoration: "none"}} href="https://vimeo.com/496060265" target="_blank" rel="noreferrer">
                <Button.Button>
                    LIVE DEMO
                </Button.Button>
            </a>
            </Button>
        </AboutSection>
    )
}